'use client';

import { LandingHeader } from '@/components/landing/header';
import { LandingBreadcrumbs } from '@/components/landing/breadcrumbs';

export default function ContactPage() {
  return (
    <>
      <main>
        <section className="bg-background py-12 md:py-16 px-4">
          <div className="max-w-3xl mx-auto">
            <LandingBreadcrumbs
              items={[
                { label: 'Help', href: '/help' },
                { label: 'Contact Us' },
              ]}
            />

            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                We&apos;re here to <span className="text-primary">help</span>.
              </h1>
              <p className="text-lg text-muted-foreground">
                Have a question about Rudrise? Our team typically responds within
                24 hours.
              </p>
            </div>

            {/* Content Cards */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Left Column */}
              <div className="border border-border rounded-lg p-8 bg-card">
                <h2 className="text-2xl font-bold mb-6">
                  Let&apos;s talk about your LaTeX workflow.
                </h2>

                <p className="text-muted-foreground mb-6">
                  We&apos;re here to ensure your technical writing process is as
                  smooth as possible. Reach out to our team if you need assistance
                  with:
                </p>

                <ul className="space-y-4 mb-8">
                  <li className="flex gap-3">
                    <span className="font-bold text-foreground">
                      Account &amp; Billing:
                    </span>
                    <span className="text-muted-foreground">
                      Help with subscriptions, managing your profile, or payment
                      questions.
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <span className="font-bold text-foreground">
                      Enterprise &amp; Teams:
                    </span>
                    <span className="text-muted-foreground">
                      Custom licensing, group deployment, and priority support for
                      research labs and universities.
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <span className="font-bold text-foreground">
                      Technical Support:
                    </span>
                    <span className="text-muted-foreground">
                      Questions about LaTeX packages, compiler errors, or editor
                      features.
                    </span>
                  </li>
                  <li className="flex gap-3">
                    <span className="font-bold text-foreground">
                      General Feedback:
                    </span>
                    <span className="text-muted-foreground">
                      Ideas on how we can make Rudrise even better for your
                      workflow.
                    </span>
                  </li>
                </ul>

                {/* Contact Methods */}
                <div className="space-y-4">
                  <a
                    href="mailto:support@rudrise.com"
                    className="flex items-center gap-3 p-4 border border-border rounded-lg hover:bg-secondary transition-colors"
                  >
                    <svg
                      className="w-6 h-6 text-primary flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                    </svg>
                    <div>
                      <div className="font-semibold text-foreground">
                        email us at
                      </div>
                      <div className="text-primary text-sm">
                        support@rudrise.com
                      </div>
                    </div>
                  </a>

                  <a
                    href="#"
                    className="flex items-center gap-3 p-4 border border-border rounded-lg hover:bg-secondary transition-colors"
                  >
                    <svg
                      className="w-6 h-6 text-primary flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-2.59-3.26c-.36-.46-.99-.67-1.54-.46-.59.21-.97.76-.97 1.39V17h12v-2.02c0-.63-.37-1.17-.96-1.39-.55-.21-1.18 0-1.54.46l-2.65 3.26z" />
                    </svg>
                    <div>
                      <div className="font-semibold text-foreground">
                        Book an appointment
                      </div>
                      <div className="text-primary text-sm">
                        Schedule a meeting with our team
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              {/* Right Column — Image Placeholder */}
              <div className="bg-gray-900 rounded-lg border border-border h-96 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-6xl mb-2">🤝</div>
                  <p className="text-muted-foreground text-sm">
                    Support Team Photo
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
